import React from 'react';
import PropTypes from 'prop-types';

import Form from 'form/Form';
import AdminFormFields from 'admin/presentational/AdminFormFields';
import ReadOnlyField from 'admin/presentational/ReadOnlyField';
import AdminFormButtons from 'admin/presentational/AdminFormButtons';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SendMessageFormFields from 'admin/containers/sendMessage/SendMessageFormFields';


const SendMessageForm = ({ conversation, predefinedTexts, onSubmit }) => {
    const initialValues = {
            senderActorId: '' + (conversation.lastSenderIsOwner ? conversation.tenantActor.id : conversation.ownerActor.id),
            writeAsAdmin: false,
            messageText: predefinedTexts.find(o => o.key === 'DefaultFooter')?.text ?? ''
        };

    return (
        <Form
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit}>
                    <AdminFormFields>
                        <ReadOnlyField label="">
                            <Typography variant="h5">
                                Send message
                            </Typography>
                        </ReadOnlyField>

                        <SendMessageFormFields
                            tenantActor={conversation.tenantActor}
                            ownerActor={conversation.ownerActor}
                            predefinedTexts={predefinedTexts}
                        />
                    </AdminFormFields>
                    <AdminFormButtons>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={invalid}
                        >
                            Send
                        </Button>
                    </AdminFormButtons>
                </form>
            )}
        </Form>
    );
};

SendMessageForm.propTypes = {
    conversation: PropTypes.object.isRequired,
    predefinedTexts: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default SendMessageForm;
